/** 수업 자료 허브 기본 경로 (공개) */
export const CLASS_MATERIALS_BASE = '/class-materials';

/** 교사 연수 허브 기본 경로 (공개) */
export const TEACHER_TRAINING_BASE = '/teacher-training';

/** 교사 개인 수업 자료 관리 */
export const CLASS_MATERIALS_MANAGE_BASE = `${CLASS_MATERIALS_BASE}/manage`;

/** 교사 개인 연수 관리 */
export const TEACHER_TRAINING_MANAGE_BASE = `${TEACHER_TRAINING_BASE}/manage`;

/** 교사별 공개 허브 URL 접두사: `/teacher-training/h/{slug}` */
export const TEACHER_TRAINING_HOST_PREFIX = 'h';

/** 기존 단일 운영자 연수 대시보드 (레거시) */
export const TEACHER_TRAINING_LEGACY_PATH = 'legacy';

/** 방문자에게 보이는 내 허브(로비) 설정 */
export const TEACHER_TRAINING_LOBBY_PATH = `${TEACHER_TRAINING_BASE}/my`;

/** 교사 공개 slug로 쓸 수 없는 예약 경로 */
export const TRAINING_HOST_RESERVED_SLUGS = [
  TEACHER_TRAINING_LEGACY_PATH,
  'my',
  TEACHER_TRAINING_HOST_PREFIX,
  'training',
  'training-pages',
  'training-materials',
  'digital',
  'aiedutech',
  'manage',
  'admin',
] as const;

/** @deprecated `/manage` 로 이전됨 — 레거시 리다이렉트용 */
export const CLASS_MATERIALS_ADMIN_BASE = CLASS_MATERIALS_MANAGE_BASE;

/** @deprecated `/manage` 로 이전됨 — 레거시 리다이렉트용 */
export const TEACHER_TRAINING_ADMIN_BASE = TEACHER_TRAINING_MANAGE_BASE;

export const CONTENT_MANAGER_ROLES = ['teacher', 'schoolAdmin', 'superAdmin'] as const;

export type ContentManagerRole = (typeof CONTENT_MANAGER_ROLES)[number];

export const canManageOwnContent = (role?: string): role is ContentManagerRole =>
  !!role && (CONTENT_MANAGER_ROLES as readonly string[]).includes(role);

export const classMaterialsPath = (...segments: string[]): string =>
  [CLASS_MATERIALS_BASE, ...segments.filter(Boolean)].join('/');

export const teacherTrainingPath = (...segments: string[]): string =>
  [TEACHER_TRAINING_BASE, ...segments.filter(Boolean)].join('/');

export const classMaterialsManagePath = (...segments: string[]): string =>
  [CLASS_MATERIALS_MANAGE_BASE, ...segments.filter(Boolean)].join('/');

export const teacherTrainingManagePath = (...segments: string[]): string =>
  [TEACHER_TRAINING_MANAGE_BASE, ...segments.filter(Boolean)].join('/');

/** @deprecated `/teacher-training/my` 로 이전 — 로비(방문자용 허브) 설정 */
export const TEACHER_TRAINING_HOST_PROFILE_PATH = TEACHER_TRAINING_LOBBY_PATH;

export const teacherTrainingHostPath = (slug: string, ...segments: string[]): string =>
  teacherTrainingPath(TEACHER_TRAINING_HOST_PREFIX, slug, ...segments);

/** 교사 허브 내 연수 상세 (웹 에디터 본문) */
export const teacherTrainingProgramPath = (hostSlug: string, programSlug: string): string =>
  teacherTrainingHostPath(hostSlug, 'p', programSlug);

export const teacherTrainingProgramEditPath = (programId: string): string =>
  teacherTrainingManagePath('programs', programId, 'edit');

export const teacherTrainingProgramRegisterPath = (mode: 'editor' | 'link'): string =>
  teacherTrainingManagePath('programs', 'new', mode);

export const teacherTrainingLegacyPath = (): string =>
  teacherTrainingPath(TEACHER_TRAINING_LEGACY_PATH);
